export function createWebWindowApi() {
  return {
    setFullscreen(on: boolean): Promise<boolean> {
      if (on) {
        document.documentElement.requestFullscreen?.().catch(() => {});
      } else {
        document.exitFullscreen?.().catch(() => {});
      }
      return Promise.resolve(document.fullscreenElement !== null);
    },
    isFullscreen(): Promise<boolean> {
      return Promise.resolve(document.fullscreenElement !== null);
    },
  };
}
